import { useState } from "react";
import { Box, chakra, Button, Input, Stack, Text, Flex } from "@chakra-ui/react";
import { useUserData, withUserData } from "@/contexts/UserDataContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageInfo from "@/components/PageInfo";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { LinkButton } from "@/components/shared/generic";

function ForgotPassword() {
  const { resetPassword } = useUserData();

  const [hasReset, setHasReset] = useState(false);
  const [email, setEmail] = useState("");

  const onResetPassword = () => {
    resetPassword(email);
    setHasReset(true);
  };

  return (
    <>
      <PageInfo title="Forgot Password" themeColor="white" />

      <Box minH="95vh" pb={10}>
        <Navbar />

        <chakra.h1 textStyle="pageHeader" my={10} textAlign="center">
          Password Reset
        </chakra.h1>

        <Stack alignItems="center" px={2} margin="0 auto">
          <Text>Type your email below</Text>

          <Input
            maxW="md"
            autoComplete="email"
            size="lg"
            type="email"
            placeholder="joe@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {!hasReset ? (
            <Flex maxW="450px" flexDirection="column" gap={6}>
              <Text>
                If the email you entered matches an account in our system, you'll receive a password
                reset link shortly. Please check your Spam folder if you don't see it in your inbox.
              </Text>

              <LinkButton rightIcon={<ChevronRightIcon />} colorScheme="green" href="/login">
                Sign In
              </LinkButton>
            </Flex>
          ) : (
            <Button onClick={onResetPassword}>Reset Password</Button>
          )}
        </Stack>
      </Box>

      <Footer />
    </>
  );
}

export default withUserData(ForgotPassword);
